import { sessionActions } from '../../actions/user/sessionActions.js';

const INITIAL_STATE = {
    expired: false
};

const sessionReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case sessionActions.SESSION_EXPIRED:
            return { ...state, expired: true };
        case sessionActions.SESSION_EXPIRED_DISMISS:
            return { ...state, expired: false };
        default:
            return state;
    }
};

export default sessionReducers;
